import { logError } from '../../common/utils';
import { clone, pipe, filter, complement, isNil, isEmpty } from 'ramda';

const isNotNil = complement(isNil),
      isNotEmpty = complement(isEmpty);

// @qName - name of the query
// @params - apollo client query options
// https://www.apollographql.com/docs/react/api/apollo-client.html#ApolloClient.query
export const getList = async (qName, params) => {
  let data = [],
      p = pipe(
        filter(isNotNil),
        filter(isNotEmpty)
      )(params);

  p.variables = p.variables || {};
  p.fetchPolicy = p.fetchPolicy || 'no-cache';
 
  try {
    do {
      const { data: { [qName]: d } } = await window.pubClient.query(p);
      p.variables.nextToken = d.nextToken;
      data = data.concat(d.items);
    } while (p.variables.nextToken);
  } catch(err) {
    logError(err);
  };

  return data;
};


// @qName - name of the query
// @params - apollo client query options
// https://www.apollographql.com/docs/react/api/apollo-client.html#ApolloClient.query
export const getItem = async (qName, params) => {
  let response, p = clone(params);
  
  p.fetchPolicy = p.fetchPolicy || 'no-cache';
  
  try {
    const { data } = await window.pubClient.query(p); 
    response = data[qName];

  } catch(err) {
    logError(err);
  };

  return response;
};



// WEBPACK FOOTER //
// ./src/public/utils/gqlq.js